<template>
<v-container fluid>
	<div v-if="!loading">
		<div v-if="segments.length">
			<!--segments tab--><!--table head-->			
			<v-row class="mt-2 total" no-gutters>
				<v-col class="tabCell" v-for="item in headers"
					:key="item">{{item}}
				</v-col>
			</v-row>
			<v-row v-for="segment in segments" :key="segment.id" no-gutters>
				<v-col class="tabCell text-truncate text-left">{{ segment.name }}</v-col>
				<v-col class="tabCell text-truncate">{{ segment.type }}</v-col>
				<v-col class="tabCell">{{ segment.peakSize }}</v-col>
				<v-col class="tabCell">{{ segment.priceMax }}</v-col>
				<v-col class="tabCell">{{ segment.priceMin }}</v-col>
				<v-col class="tabCell">{{ segment.lowPrice }}</v-col>
				<v-col class="tabCell">{{ segment.bestQuality }}</v-col>
				<v-col class="tabCell">{{ segment.online }}</v-col>
				<v-col class="tabCell">{{ segment.offline }}</v-col>
				<v-col class="tabCell">
					<change-segment :segment="segment" 
						:gameId="gameId"
						:round="round">
					</change-segment>
					<delete-segment :segment="segment" 
						:gameId="gameId"
						:round="round">
					</delete-segment>
				</v-col>
			</v-row>
		</div>
	</div><!--!loading-->	
	<div v-else class="text-center">
		<loader></loader>
	</div> 	
</v-container>
</template>
<script>
	
	import changeSegment from './modal/changeSegment.vue'
	import deleteSegment from './modal/deleteSegment.vue'
	import Loader from '../../../layouts/Loader.vue'
		
	export default {
		props: ['gameId', 'round'],
		data (){
			return {
				headers: ['Segment','Type', 'Market size', 'Max price', 'Min price', 'Purchasing habits (lowest price)', 'Purchasing habits (best quality)','Purchasing preferences (on-line)','Purchasing preferences(off-line)', 'Action']
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			segments () {
				return this.$store.getters.segments
			}
		},
		components: {
			changeSegment,
			deleteSegment,
			Loader
		}
	}
</script>


		
